import { RoutesEnum } from '@enums/routes.enum';
import { TourE } from '@enums/tour.enum';
import { PlatformTourI } from '@interfaces/platform-tour.interface';

export const platformTours: PlatformTourI[] = [
  {
    tour: TourE.ATTENDANCE_TOUR,
    forRoute: `/${RoutesEnum.PANEL}/${RoutesEnum.CHAT}`,
    navigate: true,
    config: {
      steps: [
        {
          element: '.chatlistcontainertabs .mat-tab-label:nth-of-type(1)',
          intro: 'TOUR_ATTENDANCES_TAB',
          title: 'TOUR_ATTENDANCES_TAB_TITLE',
        },
        {
          element: '.chatlistcontainertabs .mat-tab-label:nth-of-type(2)',
          intro: 'TOUR_ATTENDANCES_GROUP_TAB',
          title: 'TOUR_ATTENDANCES_GROUP_TAB_TITLE',
        },
        {
          element: '.chatlistcontainertabs .mat-tab-label:nth-of-type(3)',
          intro: 'TOUR_ATTENDANCES_EMAIL_TAB',
          title: 'TOUR_ATTENDANCES_EMAIL_TAB_TITLE',
        },
        {
          element: '.chatlistheader',
          intro: 'TOUR_ATTENDANCES_FILTERS',
          title: 'TOUR_ATTENDANCES_FILTERS_TITLE',
        },
        {
          element: '.chatcontainerheader__toogle button:nth-of-type(1)',
          intro: 'TOUR_ATTENDANCES_CHAT_BUTTON',
          title: 'TOUR_ATTENDANCES_CHAT_BUTTON_TITLE',
        },
        {
          element: '.chatcontainerheader__toogle button:nth-of-type(2)',
          intro: 'TOUR_ATTENDANCES_TELEPHONE_BUTTON',
          title: 'TOUR_ATTENDANCES_TELEPHONE_BUTTON_TITLE',
        },
        {
          element: '.chatcontainerheader__pause button',
          intro: 'TOUR_ATTENDANCES_PAUSE_BUTTON',
          title: 'TOUR_ATTENDANCES_PAUSE_BUTTON_TITLE',
        },
        {
          element: '.chat__tabs .mat-tab-label:nth-of-type(1)',
          intro: 'TOUR_ATTENDANCES_CONTACT_DETAILS',
          title: 'TOUR_ATTENDANCES_CONTACT_DETAILS_TITLE',
          position: 'left',
        },
        {
          element: '.chat__tabs .mat-tab-label:nth-of-type(2)',
          intro: 'TOUR_ATTENDANCES_TIMELINE',
          title: 'TOUR_ATTENDANCES_TIMELINE_TITLE',
          position: 'left',
        },
        {
          element: '.chat__tabs .mat-tab-label:nth-of-type(3)',
          intro: 'TOUR_ATTENDANCES_CONTACT_LIST',
          title: 'TOUR_ATTENDANCES_CONTACT_LIST_TITLE',
          position: 'left',
        },
        {
          element: '.chat__tabs .mat-tab-label:nth-of-type(4)',
          intro: 'TOUR_ATTENDANCES_USERS',
          title: 'TOUR_ATTENDANCES_USERS_TITLE',
          position: 'left',
        },
      ],
    },
  },
  {
    tour: TourE.DASHBOARD_TOUR,
    navigate: true,
    forRoute: `/${RoutesEnum.PANEL}/${RoutesEnum.DASHBOARD}`,
    config: {
      steps: [
        {
          intro: 'TOUR_DASHBOARD_MAIN',
          title: 'TOUR_DASHBOARD_MAIN_TITLE',
        },
        {
          element: '.menu li:nth-of-type(2)',
          intro: 'TOUR_DASHBOARD_ATTENDANCE',
          title: 'TOUR_DASHBOARD_ATTENDANCE_TITLE',
          position: 'right',
        },
      ],
    },
  },
  {
    tour: TourE.NAVBAR_TOUR,
    config: {
      steps: [
        {
          element: '.wrap-button.theme button',
          intro: 'TOUR_NAVBAR_THEME',
          title: 'TOUR_NAVBAR_THEME_TITLE',
        },
        {
          element: '.language-selector',
          intro: 'TOUR_NAVBAR_LANGUAGE',
          title: 'TOUR_NAVBAR_LANGUAGE_TITLE',
        },
        {
          element: '.wrap-button.help button',
          intro: 'TOUR_NAVBAR_HELP',
          title: 'TOUR_NAVBAR_HELP_TITLE',
        },
        {
          element: '.wrap-button.connection button',
          intro: 'TOUR_NAVBAR_CONNECTION',
          title: 'TOUR_NAVBAR_CONNECTION_TITLE',
        },
        {
          element: '.wrap-button.chat button',
          intro: 'TOUR_NAVBAR_NOTIFICATION',
          title: 'TOUR_NAVBAR_NOTIFICATION_TITLE',
        },
        {
          element: '.usermenu',
          intro: 'TOUR_NAVBAR_MODULES',
          title: 'TOUR_NAVBAR_MODULES_TITLE',
        },
        {
          element: '.user__avatar',
          intro: 'TOUR_NAVBAR_PROFILE',
          title: 'TOUR_NAVBAR_PROFILE_TITLE',
        },
      ],
    },
  },
  {
    tour: TourE.SES_CONFIG_TOUR,
    config: {
      steps: [
        {
          element: '.dkim-keys',
          intro: 'TOUR_DKIM_SES_INTRO',
          title: 'TOUR_DKIM_SES_TITLE',
        },
        {
          element: '.dkim-keys',
          intro: 'TOUR_DKIM_SES_INTRO_2',
          title: 'TOUR_DKIM_SES_TITLE',
        },
      ],
    },
  },
];
